import styled from "styled-components";

export const ButtonGroup = styled.div`
  ${({ theme }) => theme.boxShadow};
  align-items: center;
  background-color: ${({ theme }) => theme.colors.backgroundElevated1};
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  width: fit-content;
  gap: ${({ theme }) => theme.spacing.spacing2.toString()};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing1.toString()} ${theme.spacing.spacing2.toString()}`};
`;
